<template>
  <vue-load-image>
    <img class="real-image" slot="image" :src="src" alt="" />
    <div slot="preloader" class="preload-image">
      <img :src="preloadSrc" />
    </div>
  </vue-load-image>
</template>

<script>
import VueLoadImage from 'vue-load-image';

export default {
  props: {
    src: {
      type: String,
    },
    preloadSrc: {
      type: String,
    },
  },
  components: {
    'vue-load-image': VueLoadImage,
  },
};
</script>

<style lang="scss" scoped>
.vue-load-image {
  //   width: 100%;
  //   height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.real-image {
  object-fit: cover;
  width: 100%;
}

.preload-image {
  width: 100%;
  position: relative;
  img {
    width: 100%;
    object-fit: cover;
  }
}

i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
  font-size: 2rem;
}
</style>
